<template>
  <div>
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <vs-button @click="goBack" icon="keyboard_backspace">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Contacts</h3>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
      </vs-row>
      <div>
        <!-- AgGrid Table -->
        <DataGrid
          :context="'ContactLists'"
          ref="ContactLists"
          :columnDefs="columnDefs"
          :dataSource="dataSource"
          :rowSelection="'single'"
        >
        </DataGrid>
      </div>
    </vx-card>
  </div>
</template>

<script>
// var address = function(params) {
//   console.log("asdasdasd", params);

//   // return '$' + params.value
// };

var seniorityFormatter = function (params) {
  // console.log("seniority", params);
  // return '$' + params.value
}

var DatefilterParams = {
  comparator: function (filterLocalDateAtMidnight, cellValue) {
    // In the example application, dates are stored as dd/mm/yyyy
    // We create a Date object for comparison against the filter date
    var dateParts = cellValue.split('/')
    var day = Number(dateParts[2])
    var month = Number(dateParts[1]) - 1
    var year = Number(dateParts[0])
    var cellDate = new Date(day, month, year)

    // Now that both parameters are Date objects, we can compare
    if (cellDate < filterLocalDateAtMidnight) {
      return -1
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1
    } else {
      return 0
    }
  },
  browserDatePicker: true,
  minValidYear: 2000
}
import defineAbilitiesFor from '@/config/abilities'
import DataGrid from '@/components/aggrid/Aggrid.vue'
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
export default {
  components: {
    DataGrid
  },
  data () {
    return {
      contacts: [],
      dataSource: [],
      abilities: null,
      records: [],
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'transactions',
          suppressHeaderMenuButton: true,
          cellRenderer: 'CellRendererActions',
          pinned: true,
          width: 120
        },
        {
          headerName: 'Company',
          field: 'company_name',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Address',
          field: 'address',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Title',
          field: 'title',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'ForeName',
          field: 'forename',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Surname',
          field: 'surname',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Job Title',
          field: 'job_title',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        // {
        //   headerName: "Email",
        //   field: "email",
        //   filter: "agTextColumnFilter",
        //   filterParams: {
        //     buttons: ["apply", "reset"],
        //     maxNumConditions: 4
        //   }
        // },
        //       {
        //         headerName: "Mobile",
        //         field: "mobile",
        //         filter: "agTextColumnFilter",
        //         filterParams: {
        //           buttons: ["apply", "reset"],
        //           maxNumConditions: 4
        //         }
        //       },
        //       {
        //   headerName: "DDI",
        //   field: "ddi",
        //   filter: "agTextColumnFilter",
        //   filterParams: {
        //     buttons: ["apply", "reset"],
        //     maxNumConditions: 4
        //   }
        // },
        {
          headerName: 'Seniority',
          field: 'seniority_name',
          valueFormatter: seniorityFormatter,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        // {
        //   headerName: "Social Media",
        //   field: "social_media",
        //   filter: "agTextColumnFilter",
        //   filterParams: {
        //     buttons: ["apply", "reset"],
        //     maxNumConditions: 4
        //   }
        // },
        {
          headerName: 'Role',
          field: 'role_name',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        },
        {
          headerName: 'Sub Role',
          field: 'sub_role',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            maxNumConditions: 4
          }
        }
      ]
    }
  },
  computed: {},
  methods: {
    getDataSource () {
      var self = this
      this.dataSource = {
        getRows (params) {
          self.$store
            .dispatch('contactsManagement/fetchAllDBContacts', params.request)
            .then(function (response) {
              let response_data = response.rows

              setTimeout(() => {
                if (response_data) {
                  if (response_data.length > 0) {
                    self.$refs.ContactLists.gridApi.hideOverlay()
                    params.success({ rowData: response.rows , rowCount: response.lastRow })
                  } else {
                    self.$refs.ContactLists.gridApi.showNoRowsOverlay()
                    return params.success({ rowData: [] })
                  }
                } else {
                  params.fail()
                }
              }, 200)
            })
            .catch(err => {
              console.error(err)
            })
        }
      }
    },
    goBack: function () {
      this.$router.go(-1)
    },
    addContact () {
      this.$router.push({ path: 'contacts/add' })
    }
  },
  beforeMount () {
    this.getDataSource()
  },
  mounted () {},
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }
    this.campaignId = this.$route.params.campaignId
  }
}
</script>
